import { useMutation, useQueryClient } from '@tanstack/react-query';
import { App } from 'antd';
import { handleError } from 'api';
import { ExpensesApiService } from 'features/expenses-report/api/reports-api.service';
import { CreateFacilityDTO } from 'features/facilities/api/facilities-api.service';

import { ExpenseseQueryKeys } from './query-keys';

const { createReportExpenses } = ExpensesApiService();

export const useCreateExpenses = () => {
  const { message } = App.useApp();
  const queryClient = useQueryClient();

  return useMutation(
    (payload: CreateFacilityDTO) => {
      return createReportExpenses(payload);
    },
    {
      onError: (error) => {
        const uiMessage = handleError(error);

        message.error(uiMessage);
      },
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: ExpenseseQueryKeys.all,
        });
      },
    },
  );
};
